export const colors = {
  white: '#ffffff',
  backgroundLight: '#f9fafb',
  darkBlue: '#0d5274',
  lightBlue: '#256382',
  faintBlue: '#e7eef1',
  midGrey: '#707070',
  lightGrey: '#d6d8d8',
  midGrey_025: 'rgba(112,112,112,0.25)',
}
